import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "18",
  viewBox: "0 0 12 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.24239 7.11298L7.41515 4.40843L9.62873 2.71926L6.87488 2.69397L5.99971 0L5.12512 2.69162L2.37127 2.7169L4.58485 4.40608L3.75761 7.11063L6.00029 5.46438L8.24239 7.11298ZM5.89303 13.1441L11.4994 10.2109V7.27702L5.90044 10.2062L0.5 7.34346V10.2832L5.89303 13.1441ZM5.90044 15.0644L0.5 12.2017V15.1414L5.8936 18L11.5 15.0667V12.1329L5.90044 15.0644Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }